import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronUpinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeWidth: 2,
		d: "M20.505 15.462L12.058 6.86l-8.446 8.602",
		fill: "none",
		strokeLinecap: "square",
		strokeLinejoin: "round"
	})
});
export default SvgChevronUpinline;
